// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_3GS8Z _2iT_8","spinnerContainer":"_1pS6w _3oB5M"};


//////////////////
// WEBPACK FOOTER
// ./src/components/loader/style.css
// module id = 465
// module chunks = 0